import React, { useState, useContext } from 'react'

import useFetchData from 'hooks/fetch-data'

import { ItemContainer, Section, EmptySection } from 'components/preventative-maintenance/common/components'
import { StatusComponent } from 'components/common/others'

import enums from 'Constants/enums'

import { get, isEmpty, orderBy } from 'lodash'

import facilities from 'Services/facilities/index'
import { Toast } from 'Snackbar/useToast'

import AddClientCompany from './add-client-company'
import AddSites from './add-sites'
import ViewComapny from './view-company'
import $ from 'jquery'
import updateActiveSiteAction from 'Actions/updateActiveSiteAction'
import updateClientCompany from 'Services/updateClientCompany'
import UpdateActiveSiteService from 'Services/UpdateActiveSiteService'

import { MainContext } from 'components/Main/provider'
import { camelizeKeys } from 'helpers/formatters'
import getActiveUserSitesAndRoles from 'Services/facilities/get-usersites-roles'
import { getApplicationStorageItem } from 'helpers/getStorageItem'
import getUserRole from 'helpers/getUserRole'
import { AssetImage } from 'components/WorkOrders/onboarding/utils'
import ImagePreview from 'components/common/image-preview'
import AddBranch from './AddBranch'
import ViewBranch from './ViewBranch'
import ContactList from './ContactList'
import { ActionButton } from 'components/common/buttons'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SiteDetails from './SiteDetails'

const Facilities = () => {
  const [sites, setSites] = useState([])
  const [siteDetails, setSiteDetails] = useState([])
  const [isOpenAddBranch, setOpenAddBranch] = useState(false)
  const [isOpenEditBranch, setOpenEditBranch] = useState(false)
  const [isOpenContact, setOpenContact] = useState(false)
  const [isOpenAddClientCompany, setOpenAddClientCompany] = useState(false)
  const [isOpenEditClientCompany, setOpenEditClientCompany] = useState(false)
  const [isOpenAddSite, setOpenAddSite] = useState(false)
  const [isOpenEditSite, setOpenEditSite] = useState(false)
  const [isOpenViewCompany, setOpenViewCompany] = useState(false)
  const [isOpenViewBranch, setOpenViewBranch] = useState(false)
  const [activeClientCompanyId, setActiveClientCompanyId] = useState('')
  const [activeClientBranchId, setActiveClientBranchId] = useState('')
  const [activeSiteId, setActiveSiteId] = useState('')
  const [anchorObj, setAnchorObj] = useState({})
  const [isAfterFiter, setAfterFilter] = useState(false)
  const [isPreviewOpen, setPreview] = useState(false)
  const loginData = JSON.parse(localStorage.getItem('loginData'))
  const { setLoginSiteData, loginSiteData, setRefetchAppMenuContext } = useContext(MainContext)
  const checkUserRole = new getUserRole()

  const noSitesMsg = (
    <>
      No sites in this company , <br /> click new to add sites
    </>
  )

  const emplySitesMessage = isEmpty(activeClientCompanyId) ? 'No company selected' : noSitesMsg

  const afterSite = clientCompanies => {
    const company = clientCompanies.find(d => d.clientCompanyId === activeClientCompanyId)
    const sites = company.listOfSite
    setSites(sites)
    const siteList = sites.find(d => d.siteId === activeSiteId)
    setSiteDetails(siteList)
    setAfterFilter(false)
    return clientCompanies
  }

  const formatStateData = d => {
    let sortedList = []
    if (!isEmpty(d)) {
      sortedList = d.map(item => ({
        ...item,
        label: item.stateName,
        value: item.stateId,
      }))
    }
    return sortedList
  }

  const { loading: branchLoading, data: branchData, reFetch } = useFetchData({ fetch: facilities.branch.get, payload: { companyId: getApplicationStorageItem('companyId'), pageindex: 0, pagesize: 0, searchString: '' }, formatter: d => get(d, 'data.list', []), defaultValue: [] })
  const { loading: stateLoading, data: stateData } = useFetchData({ fetch: facilities.getAllStateList, payload: { searchString: null }, formatter: d => formatStateData(get(d, 'data.stateList', [])), defaultValue: [] })

  const {
    loading: companyLoading,
    data: clientCompanies,
    reFetch: callClientCompanies,
  } = useFetchData({
    fetch: facilities.company.get,
    payload: { companyId: getApplicationStorageItem('companyId'), pageindex: 0, pagesize: 0, searchString: '', companybranchId: activeClientBranchId },
    formatter: d => (isAfterFiter ? afterSite(get(d, 'data.list', [])) : get(d, 'data.list', [])),
    defaultValue: [],
    condition: !isEmpty(activeClientBranchId),
  })

  // change site
  const handleSiteRadioClick = ({ siteId, siteName }, accessibleSites) => {
    $('#pageLoading').show()
    updateActiveSiteAction({ site_id: siteId })
      .then(response => {
        localStorage.setItem('siteId', siteId)
        localStorage.setItem('siteName', siteName)
        sessionStorage.setItem('siteId', siteId)
        sessionStorage.setItem('siteName', siteName)
        setLoginSiteData(prevState => ({
          ...prevState,
          siteName: siteName,
          activeSiteId: siteId,
          accessibleSites,
        }))
        $('#pageLoading').hide()
        Toast.success(' The current site is inactive and has been changed. You will be redirected to an active site.')
      })
      .catch(error => {
        $('#pageLoading').hide()
        Toast.error(error.tostMsg.msg)
      })
  }

  // change compnay
  const changeClientCompany = async comp => {
    $('#pageLoading').show()
    try {
      const { siteId, siteName } = comp.clientCompanyUsersites[0]
      const cc = await updateClientCompany({ company_id: comp.clientCompanyId, site_id: siteId })
      const ac = await UpdateActiveSiteService({ site_id: siteId })

      Toast.success('The current client company is inactive and has been changed. You will be redirected to an active client company.')

      setLoginSiteData(prevState => ({
        ...prevState,
        accessibleSites: comp.clientCompanyUsersites,
        activeClientCompanyId: comp.clientCompanyId,
        clientCompanyName: comp.clientCompanyName,
        siteName: siteName,
      }))

      localStorage.setItem('clientCompanyName', comp.clientCompanyName)
      localStorage.setItem('siteId', siteId)
      localStorage.setItem('siteName', siteName)
      localStorage.setItem('activeClientCompanyId', comp.clientCompanyId)
      sessionStorage.setItem('clientCompanyName', comp.clientCompanyName)
      sessionStorage.setItem('siteId', siteId)
      sessionStorage.setItem('siteName', siteName)
      sessionStorage.setItem('activeClientCompanyId', comp.clientCompanyId)
    } catch (error) {
      console.log(error)
      Toast.error('Something went wrong!')
    }
    $('#pageLoading').hide()
  }

  const companyMenuOptions = [
    { id: 1, name: 'View', action: d => viewCompany(d) },
    { id: 2, name: 'Edit', action: d => editCompany(d) },
    { id: 3, name: 'Contacts', action: d => viewContact(d) },
  ]

  const branchMenuOptions = [{ id: 1, name: 'View', action: d => viewBranch(d) }, ...(checkUserRole.isCompanyAdmin() || checkUserRole.isSuperAdmin() ? [{ id: 2, name: 'Edit', action: d => editBranch(d) }] : [])]

  const onEditClick = id => {
    setActiveClientBranchId(id)
    callClientCompanies()
    setActiveClientCompanyId('')
    setActiveSiteId('')
    setOpenContact(false)
  }

  const onClientCompanyClick = (id, listOfSite) => {
    setActiveClientCompanyId(id)
    setSites(listOfSite)
    setActiveSiteId('')
    setOpenContact(false)
  }

  const onSiteClick = val => {
    setActiveSiteId(val.siteId)
    setSiteDetails(val)
    setOpenContact(false)
  }

  const editCompany = data => {
    setAnchorObj(data)
    if (!isEmpty(activeSiteId)) setAfterFilter(true)
    setOpenEditClientCompany(true)
  }

  const viewCompany = data => {
    setOpenViewCompany(true)
    setAnchorObj(data)
  }

  const editBranch = data => {
    setAnchorObj(data)
    setOpenEditBranch(true)
  }

  const viewBranch = data => {
    setOpenViewBranch(true)
    setAnchorObj(data)
  }

  const viewContact = data => {
    setOpenContact(true)
    setAnchorObj(data)
  }

  const editSite = () => {
    setAnchorObj(siteDetails)
    setOpenEditSite(true)
    setAfterFilter(true)
  }

  const getStatus = status => {
    const statusLabel = enums.USER_STATUS_CHIPS.find(d => d.value === status)
    return statusLabel ? <StatusComponent color={statusLabel?.color} label={statusLabel?.label} size='small' /> : 'N/A'
  }

  const getContacts = site => {
    return <div>{get(site, 'sitecontactData.sitecontactName', 'N/A') !== 'N/A' ? <StatusComponent color='#848484' label={get(site, 'sitecontactData.sitecontactName')} size='medium' /> : 'N/A'}</div>
  }

  const parse = key => get(siteDetails, [key], 'N/A') || 'N/A'

  const handleSiteAdd = () => {
    setOpenAddSite(true)
    setAfterFilter(true)
  }

  const reFetchFacilityData = async type => {
    if (type === 1) reFetch()
    callClientCompanies()
    if (checkUserRole.isSuperAdmin()) {
      setRefetchAppMenuContext(true)
      localStorage.setItem('headerDataUpdate', Date.now())
    } else {
      await getUserFacilitiesData()
    }
  }

  const getUserFacilitiesData = async () => {
    try {
      const res = await getActiveUserSitesAndRoles(get(loginData, 'uuid', ''))
      if (res.success > 0) {
        const data = camelizeKeys(res.data)
        const clientCompany = get(data, 'clientCompany', []).find(d => d.clientCompanyId === getApplicationStorageItem('activeClientCompanyId'))
        const clientCompanyUsersites = !isEmpty(clientCompany) > 0 ? clientCompany.clientCompanyUsersites : []
        const currentActiveSite = clientCompanyUsersites.find(e => e.siteId === getApplicationStorageItem('siteId'))

        setLoginSiteData(prevState => {
          const updatedLoginSiteData = {
            ...prevState,
            defaultSiteName: get(data, 'defaultSiteName', ''),
            companyName: get(prevState, 'companyName', localStorage.getItem('companyName')),
            defaultCompanyName: get(prevState, 'defaultCompanyName', localStorage.getItem('defaultCompanyName')),
            userroles: get(data, 'userroles', []),
            client_company: get(data, 'clientCompany', []),
            accessibleSites: clientCompanyUsersites,
            activeClientCompanyId: get(clientCompany, 'clientCompanyId', prevState.activeClientCompanyId),
            clientCompanyName: get(clientCompany, 'clientCompanyName', prevState.clientCompanyName),
            activeSiteId: get(currentActiveSite, 'siteId', prevState.activeSiteId),
            siteName: get(currentActiveSite, 'siteName', prevState.siteName),
          }

          // // Update session storage
          Object.keys(updatedLoginSiteData).forEach(key => {
            sessionStorage.setItem(key, JSON.stringify(updatedLoginSiteData[key]))
          })
          sessionStorage.setItem('siteId', get(currentActiveSite, 'siteId', prevState.activeSiteId))
          //need to update localstorage as well due to when do open in new tab its taking new context state which will default take from localstorage
          localStorage.setItem('clientCompanyName', get(clientCompany, 'clientCompanyName', prevState.clientCompanyName))
          localStorage.setItem('activeClientCompanyId', get(clientCompany, 'clientCompanyId', prevState.activeClientCompanyId))
          localStorage.setItem('siteId', get(currentActiveSite, 'siteId', prevState.activeSiteId))
          localStorage.setItem('siteName', get(currentActiveSite, 'siteName', prevState.siteName))

          if (!isEmpty(clientCompanyUsersites) && !clientCompanyUsersites.some(e => e.siteId === updatedLoginSiteData.activeSiteId)) {
            handleSiteRadioClick(clientCompanyUsersites[0], clientCompanyUsersites)
          }
          if (isEmpty(clientCompany)) {
            changeClientCompany(get(data, 'clientCompany', [])[0])
          }

          if (!isEmpty(get(res, 'data.client_company', [])) || !isEmpty(get(res, 'data.usersites', []))) {
            // console.log('client company data - ', get(res, 'data.client_company', []))
            // console.log('site data - ', get(res, 'data.usersites', []))
            const loginData = JSON.parse(localStorage.getItem('loginData'))
            const updatedLoginData = {
              ...loginData,
            }
            if (!isEmpty(get(res, 'data.client_company', []))) {
              updatedLoginData.client_company = get(res, 'data.client_company', [])
            }
            if (!isEmpty(get(res, 'data.usersites', []))) {
              updatedLoginData.usersites = get(res, 'data.usersites', [])
            }
            localStorage.setItem('loginData', JSON.stringify(updatedLoginData))
          }
          localStorage.setItem('headerDataUpdate', Date.now())

          return updatedLoginSiteData
        })
      } else {
        Toast.error(res.message)
      }
    } catch (error) {
      console.log('error - ', error)
      Toast.error('Something went wrong !')
    }
  }

  const handleManagers = data => {
    return !isEmpty(data)
      ? data?.map(d => (
          <div className='mr-1 mb-2'>
            <StatusComponent color='#848484' label={d.name} size='small' />
          </div>
        ))
      : 'N/A'
  }

  return (
    <div style={{ background: '#fff', height: 'calc(100vh - 128px)' }}>
      <div className='d-flex ' style={{ height: '100%' }}>
        {/* BRANCHES */}
        <Section loading={branchLoading} title='Company Branches' onAction={() => setOpenAddBranch(true)} noAction={!(checkUserRole.isCompanyAdmin() || checkUserRole.isSuperAdmin())} isActionDisabled={checkUserRole.isBranchAdmin()} style={{ width: '250px' }} innerStyle={{ height: 'calc(100vh - 168px)' }}>
          {!isEmpty(branchData) &&
            orderBy(branchData, [e => e.companyBranchName?.toLowerCase()])?.map(branch => (
              <ItemContainer id={branch.companybranchId} onClick={() => onEditClick(branch.companybranchId)} data={branch} count={get(branch, 'totalClientCompanyCount', '0')} hasMenu menuOptions={branchMenuOptions} key={branch.companybranchId} isActive={branch.companybranchId === activeClientBranchId} title={branch.companyBranchName} />
            ))}
        </Section>
        {/* COMPANIES */}
        <Section loading={branchLoading || companyLoading} isActionDisabled={isEmpty(activeClientBranchId)} title='Client Companies' onAction={() => setOpenAddClientCompany(true)}>
          {isEmpty(clientCompanies) || isEmpty(activeClientBranchId) ? (
            <EmptySection message={!isEmpty(activeClientBranchId) && isEmpty(clientCompanies) ? 'No companies in this branch. Click "New" to add a company.' : 'No branch selected'} />
          ) : (
            orderBy(clientCompanies, [e => e.clientCompanyName?.toLowerCase()], ['asc'])?.map(company => (
              <ItemContainer
                id={company.clientCompanyId}
                onClick={() => onClientCompanyClick(company.clientCompanyId, company.listOfSite)}
                data={company}
                count={company.listOfSite.length}
                hasMenu
                menuOptions={companyMenuOptions}
                key={company.clientCompanyId}
                isActive={company.clientCompanyId === activeClientCompanyId}
                title={company.clientCompanyName}
              />
            ))
          )}
        </Section>
        {isOpenContact ? (
          <div style={{ padding: '10px', width: '100%' }}>
            <div className='d-flex flex-row align-items-center'>
              <ActionButton style={{ marginRight: '5px' }} action={() => setOpenContact(false)} icon={<ArrowBackIcon fontSize='small' />} tooltip='Contacts' />
              <div style={{ fontWeight: 800, fontSize: '16px', marginRight: '8px' }}>Contacts</div>
            </div>
            <ContactList obj={anchorObj} />
          </div>
        ) : (
          <>
            <Section loading={branchLoading || companyLoading} isActionDisabled={isEmpty(activeClientCompanyId)} title='Facilities' onAction={handleSiteAdd}>
              {isEmpty(sites) || isEmpty(activeClientCompanyId) ? (
                <EmptySection message={emplySitesMessage} />
              ) : (
                orderBy(sites, [e => e.siteName?.toLowerCase()], ['asc']).map(site => <ItemContainer id={site.siteId} onClick={() => onSiteClick(site)} key={site.siteId} isActive={site.siteId === activeSiteId} title={site.siteName} hideCount={false} />)
              )}
            </Section>
            <Section loading={branchLoading || companyLoading} style={{ width: 'calc(100vw - 500px)' }} isActionDisabled={isEmpty(activeSiteId)} title='Facilities Details' onAction={editSite} isEditIcon>
              {isEmpty(activeSiteId) || isEmpty(activeClientCompanyId) || isEmpty(siteDetails) ? (
                <EmptySection message='No Facilities Selected' />
              ) : (
                <div className='p-2' style={{ height: '100%' }}>
                  <SiteDetails siteDetails={siteDetails} />
                </div>
              )}
            </Section>
          </>
        )}
      </div>
      {isPreviewOpen && <ImagePreview open={isPreviewOpen} onClose={() => setPreview(false)} imageIndex={0} images={[{ imageFileNameUrl: siteDetails.profileImage }]} urlKey='imageFileNameUrl' hideRotateButton={true} />}
      {isOpenAddClientCompany && <AddClientCompany open={isOpenAddClientCompany} onClose={() => setOpenAddClientCompany(false)} reFetch={() => reFetchFacilityData(1)} stateData={stateData} clientBranchId={activeClientBranchId} branchData={branchData} />}
      {isOpenEditClientCompany && <AddClientCompany open={isOpenEditClientCompany} onClose={() => setOpenEditClientCompany(false)} reFetch={() => reFetchFacilityData(1)} isEdit anchorObj={anchorObj} stateData={stateData} clientBranchId={activeClientBranchId} branchData={branchData} />}
      {isOpenAddSite && <AddSites open={isOpenAddSite} onClose={() => setOpenAddSite(false)} reFetch={() => reFetchFacilityData(2)} clientCompanyId={activeClientCompanyId} stateData={stateData} clientCompanies={clientCompanies} />}
      {isOpenEditSite && <AddSites open={isOpenEditSite} onClose={() => setOpenEditSite(false)} reFetch={() => reFetchFacilityData(2)} anchorObj={anchorObj} clientCompanyId={activeClientCompanyId} isEdit stateData={stateData} clientCompanies={clientCompanies} />}
      {isOpenViewCompany && <ViewComapny open={isOpenViewCompany} onClose={() => setOpenViewCompany(false)} anchorObj={anchorObj} />}
      {isOpenAddBranch && <AddBranch open={isOpenAddBranch} onClose={() => setOpenAddBranch(false)} reFetch={() => reFetchFacilityData(1)} />}
      {isOpenEditBranch && <AddBranch open={isOpenEditBranch} onClose={() => setOpenEditBranch(false)} reFetch={() => reFetchFacilityData(1)} isEdit anchorObj={anchorObj} />}
      {isOpenViewBranch && <ViewBranch open={isOpenViewBranch} onClose={() => setOpenViewBranch(false)} anchorObj={anchorObj} />}
    </div>
  )
}

export default Facilities
